import { createContext } from "react";

const InventoryServiceContext = createContext();

export default InventoryServiceContext;